import { AxiosInstance } from 'axios';
import http from '@/views/student/http';

function createAccountCtor(http: AxiosInstance) {
  return async function qualifyStudent(projectId, sessionId, form) {
    const { data } = await http.post(`/checkout/${projectId}/${sessionId}/qualify`, form);
    return data;
  };
}

export default createAccountCtor(http);
